import React from "react";
import { Grid, Box, Theme, useTheme, Snackbar } from "@mui/material";
import { ScanningIcon } from "./ScanningIcon/ScanningIcon";
import { useSelector, useDispatch } from "react-redux";
import Icon from "@mui/material/Icon";
import classNames from "classnames";
import { CustomSnackbar } from "src/components/CustomSnackbar/CustomSnackbar";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import * as AppActionCreators from "src/redux/actions/App.Actions";
import { StatusBarSummary } from "./StatusBarSummary";
import { ColoredBackground } from "../ColoredBars/ColoredBars";
import { ErrorType } from "src/pages/Errors/ErrorsWindow";
import { OpsLinkUnackedCounter } from "./OpsLinkUnackedCounter";

const statusBarStyles = (theme: Theme): any => ({
  backgroundColor: theme.custom.statusBar.backgroundColor,
  color: theme.custom.statusBar.foregroundColor,
  margin: "0",
  flexGrow: 0,
  padding: 0,
  height: theme.custom.statusBar.height,
  // explicitly cast as literal type - see https://github.com/mui/material-ui/issues/8928
  position: "relative" as const,
  width: "100%",
  boxShadow: "0px -2px 4px -1px rgba(0,0,0,0.2), 0px -4px 5px 0px rgba(0,0,0,0.14), 0px -1px 10px 0px rgba(0,0,0,0.12)",
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  "&.shiftRight": {
    marginLeft: `${theme.custom.AppLaunchpad.width}px`,
    width: `calc(100% - ${theme.custom.AppLaunchpad.width}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
});

const wifiIconStyles = (): object => ({
  zIndex: 1,
  margin: "0 5px",
});

const containerStyles = (): object => ({
  alignItems: "center",
  height: "100%",
});

export const AppStatusBar = (): JSX.Element => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isConnected = useSelector((state: IRootState) => state.status.isConnected);
  const snackbar = useSelector((state: IRootState) => state.snackbar);

  const handleClickLink = async (): Promise<boolean> => {
    return new Promise((resolve: any, reject: any) => {
      resolve(true);
    });
  };

  const handleCloseSnackbar = (): void => {
    dispatch(AppActionCreators.closeSnackbar());
  };

  return (
    <Box sx={statusBarStyles(theme)}>
      <Grid container sx={containerStyles()} direction="row" justifyContent="flex-end">
        <ColoredBackground statusBar={true} />
        <StatusBarSummary />

        {/* Error icons for flights, violations and qualifications */}
        <ScanningIcon errorType={ErrorType.FLIGHT_ERRORS} isDisabled={false} handleClickLink={handleClickLink} />
        <ScanningIcon errorType={ErrorType.VIOLATION_ERRORS} isDisabled={false} handleClickLink={handleClickLink} />
        <ScanningIcon errorType={ErrorType.QUALIFICATION_ERRORS} isDisabled={false} handleClickLink={handleClickLink} />

        <OpsLinkUnackedCounter />

        <Icon sx={wifiIconStyles()} color="inherit">
          {isConnected ? "wifi" : "wifi_off"}
        </Icon>
      </Grid>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackbar.open}
        autoHideDuration={snackbar.closeDelay}
        onClose={handleCloseSnackbar}
        sx={{ bottom: "60px !important" }}
      >
        <Box>
          <CustomSnackbar {...snackbar} />
        </Box>
      </Snackbar>
    </Box>
  );
};
